module.exports = __webpack_public_path__ + "img/yszc.5794a322.png";